import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import _ from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import {
	IAssessmentResultData,
	IResultDataInfo,
} from '../actions/assessmentResult';
import GridChart, {
	ChartTypeEnum,
	IChartInfo,
	ITableInfo,
} from '../components/GridChart';
import { IRootState } from '../reducers';
import { IAssessmentResultState } from '../reducers/assessmentResult';
import i18n from '../resources/i18n';
import AssessmentResultScenarioFactory from '../scenario/AssessmentResultScenarioFactory';

const styles = (theme: Theme) =>
	createStyles({
		contentArea: {
			display: 'flex',
			flexDirection: 'column',
		},
		contentArea1: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
		},
		contentArea11: {
			height: '41px',
			padding: '8px 8px',
		},
		contentArea12: {
			alignItems: 'center',
			display: 'flex',
			flexDirection: 'row',
			marginRight: '12px',
		},
		contentArea2: {
			display: 'flex',
			flexDirection: 'row',
			position: 'relative',
		},
		contentArea3: {
			display: 'flex',
			flexDirection: 'column',
			padding: '10px',
		},
		contentArea31: {
			padding: '11px 10px',
		},
		contentArea32: {
			border: '2px solid #ccc',
			borderRadius: '10px',
			marginLeft: '30px',
			padding: '10px',
		},
		contentAreaIcon: {
			alignItems: 'center',
			display: 'flex',
			marginLeft: '12px',
		},
		hiddenArea: {
			display: 'none',
		},
		printArea: {
			alignItems: 'center',
			display: 'flex',
			justifyContent: 'flex-end',
		},
		printBtn: {
			marginRight: '15px',
		},
		rankTitle: {
			alignItems: 'center',
			display: 'flex',
			fontSize: '18px',
			marginLeft: '8px',
		},
		root: {
			flexGrow: 1,
			padding: theme.spacing(1),
		},
		skillTitle: {
			alignItems: 'center',
			display: 'flex',
		},
		table: {
			backgroundColor: '#FFF',
		},
		tableCol: {
			borderBottom: '1px solid #ccc',
			borderRight: '1px solid #ccc',
			display: 'flex',
			flexDirection: 'column',
			width: theme.spacing(18),
		},
		tableRow: {
			display: 'flex',
			flexDirection: 'row',
		},
		title: {
			flex: 1,
			marginLeft: theme.spacing(2),
		},
	});

/**
 * アセスメント結果公開プロパティー
 */
interface IAssessmentResultProp {
	/**
	 * スキルID
	 */
	careerId: string;

	/**
	 * ランクID
	 */
	rankId: string;

	/**
	 * クラスID
	 */
	classId: string;

	adminView: boolean;

	targetuserId?: string;
}

/**
 * アセスメント結果内部States
 */
interface IState {
	/**
	 * アセスメント結果データ
	 */
	assessmentData: IAssessmentResultData;
	/**
	 * スキル名
	 */
	careerName: string;
	/**
	 * チャート情報
	 */
	chartInfo: IChartInfo[];
	/**
	 * コメント
	 */
	comment: string;
	/**
	 * ランク名
	 */
	rankName: string;
	/**
	 *
	 */
	tableData: any[];
	/**
	 * アセスメント結果表の情報
	 */
	tableInfo: ITableInfo[];
}

class AssessmentResult extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);

		this.state = {
			assessmentData: {
				assessmentResultList: [],
				averageFlg: -1,
				careerName: '',
				categoryFlg: -1,
				comment: '',
				rankName: '',
			},
			careerName: '',
			chartInfo: [],
			comment: '',
			rankName: '',
			tableData: [],
			tableInfo: [],
		};
	}

	/**
	 * 初期化
	 */
	public componentDidMount() {
		// データを検索するし、表示用なデータを作成する。
		this.props
			.fetchAssessmentResultData(this.props.token, {
				careerId: this.props.careerId,
				classId: this.props.classId,
				objectUserId: this.props.userId,
				rankId: this.props.rankId,
				userId: this.props.adminView
					? this.props.targetuserId
					: this.props.userId,
			})
			.then(() => {
				this.setState({
					assessmentData: this.props.assessmentData,
					careerName: this.props.assessmentData.careerName,
					comment: this.props.assessmentData.comment,
					rankName: this.props.assessmentData.rankName,
				});

				// 表データとチャートデータを作成する。
				this.renderGridChartData();
			});
	}

	/**
	 * 画面
	 */
	public render() {
		const { classes } = this.props;
		return (
			<div className={classes.root}>
				<Grid
					container={true}
					spacing={2}
					alignItems="stretch"
					style={{ flexWrap: 'nowrap' }}
				>
					<Grid
						item={true}
						xs={12}
						md={6}
						className={classes.skillTitle}
					>
						<div style={{ marginLeft: '15px', fontSize: '20px' }}>
							{i18n.t('AssessmentResult_0001')}
							{this.state.careerName}
						</div>
					</Grid>
					<Grid
						item={true}
						xs={12}
						md={6}
						className={classes.printArea}
					>
						<Button
							variant="contained"
							color="primary"
							className={classes.printBtn}
							onClick={this.handlePrint}
						>
							{i18n.t('AssessmentResult_0002')}
						</Button>
					</Grid>
				</Grid>
				<Grid container={true} spacing={2} alignItems="stretch">
					<Grid item={true} xs={12} md={true}>
						<Paper className={classes.table}>
							<div className={classes.contentArea}>
								<div
									className={
										this.state.rankName === '' &&
										Number(
											this.state.assessmentData.averageFlg
										) !== 1
											? classes.hiddenArea
											: classes.contentArea1
									}
								>
									<div className={classes.contentArea11}>
										<div
											hidden={this.state.rankName === ''}
										>
											<div className={classes.rankTitle}>
												{i18n.t(
													'AssessmentResult_0003'
												)}
												{this.state.rankName}
											</div>
										</div>
									</div>
									<div
										className={
											Number(
												this.state.assessmentData
													.averageFlg
											) !== 1
												? classes.hiddenArea
												: classes.contentArea12
										}
									>
										<div
											className={classes.contentAreaIcon}
										>
											<div
												style={{
													backgroundColor: '#ff0000',
													border: '5px solid #ff0000',
													borderRadius: '50%',
													height: '0px',
													width: '0px',
												}}
											/>
											<div
												style={{
													backgroundColor: '#ff0000',
													border: '1px solid #ff0000',
													height: '3px',
													width: '20px',
												}}
											/>
											<div>
												{i18n.t(
													'AssessmentResult_0004'
												)}
											</div>
										</div>
										<div
											className={classes.contentAreaIcon}
										>
											<div
												style={{
													backgroundColor: '#000',
													border: '8px solid #000',
													borderRadius: '50%',
													height: '0px',
													width: '0px',
												}}
											/>
											<div
												style={{
													backgroundColor: '#000',
													border: '1px solid #000',
													height: '3px',
													width: '20px',
												}}
											/>
											<div>
												{i18n.t(
													'AssessmentResult_0005'
												)}
											</div>
										</div>
									</div>
								</div>
								<div className={classes.contentArea2}>
									<div style={{ width: '8px' }} />
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											position: 'relative',
											width: '100%',
										}}
									>
										<GridChart
											tableInfo={this.state.tableInfo}
											data={this.state.tableData}
											chart={this.state.chartInfo}
											categoryFlg={
												this.state.assessmentData
													.categoryFlg
											}
										/>
									</div>
									<div style={{ width: '8px' }} />
								</div>
								<div className={classes.contentArea3}>
									<div className={classes.contentArea31}>
										{i18n.t('AssessmentResult_0006')}
									</div>
									<div className={classes.contentArea32}>
										{this.state.comment}
									</div>
								</div>
							</div>
						</Paper>
					</Grid>
				</Grid>
			</div>
		);
	}

	/**
	 * 印刷機能を呼び出し
	 */
	protected handlePrint = () => {
		window.print();
	};

	/**
	 * 表データとチャートデータを作成する。
	 */
	private renderGridChartData = () => {
		let tableInfos: ITableInfo[] = [];
		const tableDatas: any[] = [];
		let chartInfos: IChartInfo[] = [];
		// 結果表の列情報を作成する。
		if (Number(this.state.assessmentData.averageFlg) === 1) {
			// 平均値表示場合
			tableInfos = [
				{
					align: 'left',
					headerAlign: 'center',
					key: 'name',
					name: i18n.t('AssessmentResult_0007'),
				},
				{
					align: 'center',
					headerAlign: 'center',
					key: 'a1',
					name: i18n.t('AssessmentResult_0008'),
				},
				{
					align: 'center',
					headerAlign: 'center',
					key: 'a2',
					name: i18n.t('AssessmentResult_0009'),
				},
				{
					align: 'center',
					headerAlign: 'center',
					key: 'a3',
					name: i18n.t('AssessmentResult_0010'),
				},
				{
					align: 'center',
					headerAlign: 'center',
					key: 'count',
					name: i18n.t('AssessmentResult_0011'),
				},
				{
					align: 'center',
					headerAlign: 'center',
					key: 'chart',
					name: i18n.t('AssessmentResult_0012'),
				},
			];

			// 結果表の列データを作成する。
			for (const row of this.state.assessmentData.assessmentResultList) {
				tableDatas.push({
					a1: this.getRatio(row.score / row.maxScore),
					a2: this.getRatio(row.orgAveragePercent),
					a3: this.getRatio(row.allObjectAveragePercent),
					count: this.getStar(
						row,
						this.state.assessmentData.categoryFlg === 1
							? true
							: false
					),
					name:
						row.scoreName === '合計'
							? i18n.t(row.scoreName, { ns: 'force' })
							: row.scoreName,
				});
			}

			// チャート情報を作成する。
			chartInfos = [
				{
					color: '#0288d1',
					height: 21,
					key: 'a1',
					name: i18n.t('AssessmentResult_0008'),
					radius: 0,
					type: ChartTypeEnum.Bar,
					width: 0,
				},
				{
					color: '#000000',
					height: 5,
					key: 'a3',
					name: i18n.t('AssessmentResult_0010'),
					radius: 8,
					type: ChartTypeEnum.Line,
					width: 5,
				},
				{
					color: '#ff0000',
					height: 5,
					key: 'a2',
					name: i18n.t('AssessmentResult_0009'),
					radius: 5,
					type: ChartTypeEnum.Line,
					width: 5,
				},
			];
		} else {
			// 平均値を表示しない場合
			tableInfos = [
				{
					align: 'left',
					headerAlign: 'center',
					key: 'name',
					name: i18n.t('AssessmentResult_0007'),
				},
				{
					align: 'center',
					headerAlign: 'center',
					key: 'a1',
					name: i18n.t('AssessmentResult_0008'),
				},
				{
					align: 'center',
					headerAlign: 'center',
					key: 'count',
					name: i18n.t('AssessmentResult_0013'),
				},
				{
					align: 'center',
					headerAlign: 'center',
					key: 'chart',
					name: i18n.t('AssessmentResult_0012'),
				},
			];

			// 結果表の列データを作成する。
			for (const row of this.state.assessmentData.assessmentResultList) {
				tableDatas.push({
					a1: this.getRatio(row.score / row.maxScore),
					count: this.getStar(
						row,
						this.state.assessmentData.categoryFlg === 1
							? true
							: false
					),
					name:
						row.scoreName === '合計'
							? i18n.t(row.scoreName, { ns: 'force' })
							: row.scoreName,
				});
			}

			// チャート情報を作成する。
			chartInfos = [
				{
					color: '#0288d1',
					height: 21,
					key: 'a1',
					name: i18n.t('AssessmentResult_0008'),
					radius: 0,
					type: ChartTypeEnum.Bar,
					width: 0,
				},
			];
		}

		this.setState({
			chartInfo: chartInfos,
			tableData: tableDatas,
			tableInfo: tableInfos,
		});
	};

	/**
	 * 「強い」のスターを作成する。
	 * @param dataInfo アセスメント結果リスト情報
	 * @param flg カテゴリの強み判定値
	 */
	private getStar = (dataInfo: IResultDataInfo, flg: boolean): number => {
		if (!flg || dataInfo.scoreName === '合計') {
			return -1;
		}
		if (
			dataInfo.veryHigh === 0 &&
			dataInfo.high === 0 &&
			dataInfo.alittleHigh === 0
		) {
			return -1;
		}
		if (dataInfo.score >= dataInfo.veryHigh) {
			return 3;
		} else if (
			dataInfo.score < dataInfo.veryHigh &&
			dataInfo.score >= dataInfo.high
		) {
			return 2;
		} else if (
			dataInfo.score < dataInfo.high &&
			dataInfo.score >= dataInfo.alittleHigh
		) {
			return 1;
		} else if (dataInfo.score < dataInfo.alittleHigh) {
			return 0;
		} else {
			return -1;
		}
	};

	/**
	 * 率作成
	 * @param ratio
	 */
	private getRatio = (ratio: number): string => {
		if (ratio > 1) {
			return _.round(ratio * 1.0, 1).toFixed(1);
		} else {
			return _.round(ratio * 100, 1).toFixed(1);
		}
	};
}

const mapStateToProps = (state: IRootState) => ({
	assessmentData: state.assessmentResult.assessmentData,
	token: state.session.token,
	userId: state.session.userAttr.userId,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchAssessmentResultData: (token: string, arg: any) => {
		const s = AssessmentResultScenarioFactory.getAssessmentResultData(
			dispatch,
			token
		);
		return s.run(arg);
	},
});

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> &
	IAssessmentResultProp &
	IAssessmentResultState;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(AssessmentResult);

const Styled = withStyles(styles)(Connected);
const Export: React.ComponentType<IAssessmentResultProp> = Styled;

export default Export;



// WEBPACK FOOTER //
// ./src/containers/AssessmentResult.tsx